import SettingsIcon from './component'

export default SettingsIcon
